export enum EResultStatus{
    SUCCESS = 1,
    ERROR = 2
}